import React, { useEffect, useMemo, useState } from 'react'
import { Box, Button, Modal } from '@mui/material'
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  LoadScript,
} from '@react-google-maps/api'
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  geocodeByLatLng,
  geocodeByPlaceId,
  getLatLng,
} from 'react-google-places-autocomplete'
import SelectAvailableDateModal from './SelectAvailableDateModal'

const containerStyle = {
  width: '100%',
  height: '400px',
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
  zIndex: 'modal',
}

const SelectLocationModal = ({
  handleSelectLocationModal,
  selectLocationModal,
  mapCenter,
  setCenter,
  value,
  setValue,
  setZipCode,
  action = '',
  selectedService,
  center,
}) => {
  // const memoizedCenter = useMemo(() => setMapCenter(center), [center])
  const [selectAvailableDateModal, setSelectAvailableDateModal] = useState(
    false,
  )
  const user = JSON.parse(localStorage.getItem('user'))
  const [mCenter, setmCenter] = useState(
    center ?? {
      lat: 48.8584,
      lng: 2.2945,
    },
  )
  const [postalCode, setPostalCode] = useState('')
  const [travelCharges, setTravelCharges] = useState('')
  useEffect(() => {
    calculateRoute()
    if (value?.value?.place_id) {
      geocodeByAddress(value.label).then((res) =>
        extractFromAdress(res[0].address_components, 'postal_code'),
      )
      geocodeByPlaceId(value?.value?.place_id)
        .then((results) => {
          const latLng = getLatLng(results[0])
            .then((coordinates) => {
              geocodeByLatLng(coordinates).then((val) => {})
              setCenter(coordinates)
              setmCenter(coordinates)
              console.log('latLng', coordinates)
            })
            .catch((err) => console.log(err))
        })
        .catch((error) => console.error(error))
    }
  }, [value])

  const calculateRoute = async () => {
    // const directionsService = new window.google && window?.google?.maps?.DirectionsService()
    const directionsService = window.google?.maps?.DirectionsService()
    if (directionsService) {
      const results = await directionsService?.route({
        origin: user.location,
        destination: value?.label,
        travelMode: window.google.maps.TravelMode.DRIVING,
      })
      let duration = results?.routes[0]?.legs[0]?.duration?.text
      let travelCharges
      if (duration?.includes('mins')) {
        // let splittedTime = duration.split('hours');
        let hours = duration.split('hours')[0].split(' ')[0]
        let mins = duration.split('hours')[1].split(' ')[1] / 60
        if (selectedService?.client) {
          travelCharges = (Number(hours) + mins) * user?.travel_charges
          setTravelCharges(travelCharges)
        } else if (selectedService?.provider) {
          travelCharges =
            (Number(hours) + mins) * selectedService?.provider?.travel_charges
          setTravelCharges(travelCharges)
        }
      } else {
        if (selectedService?.client) {
          let hours = duration.split(' ')[0]
          travelCharges = Number(hours) * user?.travel_charges
          setTravelCharges(travelCharges)
        } else if (selectedService?.provider) {
          let hours = duration.split(' ')[0]
          travelCharges =
            Number(hours) * selectedService?.provider?.travel_charges
          setTravelCharges(travelCharges)
        }
      }
    }
    // if (selectedService?.client) {
    //   travelCharges = user?.travel_charges
    // }
  }

  function extractFromAdress(components, type) {
    for (var i = 0; i < components.length; i++)
      for (var j = 0; j < components[i].types.length; j++)
        if (components[i].types[j] == type) {
          setPostalCode(components[i].long_name)
        }
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        if (!center) {
          setCenter({ lat: pos.coords.latitude, lng: pos.coords.longitude })
        }
        // console.log(pos.coords.latitude, pos.coords.longitude);
      },
      (err) => console.error(err),
    )
  }, [])

  // console.log({ center })

  const handleSelectAvailableDateModal = () => {
    setSelectAvailableDateModal(!selectAvailableDateModal)
  }

  return (
    <div>
      <Modal
        open={selectLocationModal}
        onClose={() => handleSelectLocationModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="home-select-location-modal">
          <div>
            <h3 className="fs-24 fw-bold">Select Location</h3>
            <div className="autoplaces-container mb-2">
              <GooglePlacesAutocomplete
                selectProps={{
                  value,
                  onChange: setValue,
                  styles: {
                    control: (base, state) => ({
                      ...base,
                      border: '1px solid #08c4bb',
                      borderRadius: '8px !important',
                      // This line disable the blue border
                      boxShadow: state.isFocused ? 0 : 0,
                      '&:hover': {
                        border: '1px solid #08c4bb',
                        borderRadius: '8px !important',
                      },
                    }),
                    input: (provided) => ({
                      ...provided,
                      borderRadius: '8px !important',
                    }),
                    container: (provided) => ({
                      ...provided,
                      // border: '1px solid #08c4bb',
                      borderRadius: '8px !important',
                    }),
                  },
                }}
              ></GooglePlacesAutocomplete>
            </div>
            {/* <LoadScript googleMapsApiKey="AIzaSyBYrhwDLjzAji73YKhXj_xO1ODCMKwXjtk"> */}
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={mCenter}
              zoom={10}
              options={{
                fullscreenControl: false,
                streetViewControl: false,
                mapTypeControl: false,
              }}
            >
              <Marker
                position={center}
                opacity={1}
                visible={true}
                zIndex={99999}
              ></Marker>
            </GoogleMap>
            {/* </LoadScript> */}
            <Button
              disableElevation
              id="btn-primary-no-shadow"
              className="mt-3 pointer w-50"
              onClick={() => {
                setZipCode(Number(postalCode))
                // handleSelectLocationModal(false)
                if (action === 'open-select-available-date-modal') {
                  // localStorage.setItem('booking_location', JSON.stringify())
                  handleSelectLocationModal(false)
                  handleSelectAvailableDateModal()
                }
                handleSelectLocationModal(false)
              }}
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
      <SelectAvailableDateModal
        handleSelectAvailableDateModal={handleSelectAvailableDateModal}
        modalOpen={selectAvailableDateModal}
        screenName="profile-screen-view-all"
        selectedSubService={{
          ...selectedService,
          address: value?.label,
          latitude: mCenter?.lat,
          longitude: mCenter?.lng,
          travel_charges: travelCharges,
        }}
      />
    </div>
  )
}

export default SelectLocationModal
